/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
// Added by Adam B (Shopify Theme Support) October 20 2020 
var sections = window.theme.sections;
var slideshowAutoExtension = {
  init: function() {
    this.$container = $(this.container);
    this.speed = $('.slideshow__slides', this.$container).data('slideshow-transition-time');
    this.autoPlayEnabled = $('.slideshow__slides', this.$container).data('slideshow-transition');

    this.$container.on('slideshow_desktop_init_done', this._autoplaySlideshow.bind(this));
  },
  _autoplaySlideshow: function() {
    var $container = this.$container;

    if (this.autoPlayEnabled) {
      setInterval(function() {
        var $slide = $('.slideshow__slide--active', $container).removeClass('slideshow__slide--active');
        var $button = $('.slideshow__button--active', $container).removeClass('slideshow__button--active');
        var $slides = $('.slideshow__slide', $container);
        var currentIndex = ($slides.index($slide) + 1) % $slides.length;
        $slides.eq(currentIndex).addClass('slideshow__slide--active');
        var $buttons = $('.slideshow__button', $container).eq(currentIndex).addClass('slideshow__button--active');
        var $dot = $('.slideshow__indicator--active', $container).removeClass('slideshow__indicator--active');
        var $dots = $('.slideshow__indicator', $container);
        $dots.eq(currentIndex).trigger('click');
      }, this.speed)
    }
  }
};
sections.extend('slideshow-section', slideshowAutoExtension);

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}